import { combineReducers, Reducer } from '@reduxjs/toolkit';
import { commonReducer } from './slices/common';
import type { InjectedReducersType } from '../utils/types/injector-typings';

/**
 * Dynamic root reducer. `common` is always included; other keys come from injectors.
 */
export function createReducer(injectedReducers: InjectedReducersType = {}): Reducer {
  if (Object.keys(injectedReducers).length === 0) {
    return combineReducers({
      common: commonReducer,
    });
  }

  return combineReducers({
    common: commonReducer,
    ...injectedReducers,
  });
}
